import {
  OpportunitiesFilterPanelKeyLabel,
  OpportunitiesFilterPanelKeyOptions,
  OpportunitiesFilterPanelKeyType,
  InvitationsFilterPanelKeyLabel,
  InvitationsFilterPanelKeyType,
  InvitationsFilterPanelKeyOptions,
  opportunitiesFilterPanelKeys,
  invitationsFilterPanelKeys,
} from './constants';

export const getActivePanelFilters = ({
  searchParams,
  isInvitations,
}: {
  searchParams: URLSearchParams;
  isInvitations?: boolean;
}) => {
  if (isInvitations) {
    return Array.from(searchParams)
      .filter(([key]) => invitationsFilterPanelKeys.includes(key))
      .map(([key, value]) => ({
        key,
        label: InvitationsFilterPanelKeyLabel[key],
        type: InvitationsFilterPanelKeyType[key],
        value,
        title: InvitationsFilterPanelKeyOptions[key]?.find(
          // api returns lowercase origin values
          // so we need to compare lowercase values
          (option) => option?.value?.toLowerCase() === value?.toLowerCase(),
        )?.title,
        options: InvitationsFilterPanelKeyOptions[key],
      }));
  }
  return Array.from(searchParams)
    .filter(([key]) => opportunitiesFilterPanelKeys.includes(key))
    .map(([key, value]) => ({
      key,
      label: OpportunitiesFilterPanelKeyLabel[key],
      type: OpportunitiesFilterPanelKeyType[key],
      value,
      // for the sake of consistency, using the same logic as in invitations
      title: OpportunitiesFilterPanelKeyOptions[key]?.find(
        (option) => option?.value?.toLowerCase() === value?.toLowerCase(),
      )?.title,
      options: OpportunitiesFilterPanelKeyOptions[key],
    }));
};
